import { useDispositiveProvisionSuggestionsContext } from '@/modules/aiDP/context/dispositiveProvisionSuggestions.context';
import { useDPFormSuggestionsContext } from '@/modules/aiDP/context/dpFormSuggestions.context';
import { PulidKind } from '@/utils/pulid';

/**
 * Hook to determine whether to show the AI suggestions matcher for
 * dispositive provisions based on feature flags and other conditions.
 */
export const useShowAIDPSuggestionsMatcher = () => {
  const { targetKind } = useDispositiveProvisionSuggestionsContext();

  const { hasUnacknowledgedRecipientSuggestions } =
    useDPFormSuggestionsContext();

  if (targetKind === PulidKind.Entity) {
    if (!hasUnacknowledgedRecipientSuggestions) {
      return false;
    }

    return true;
  }

  if (targetKind === PulidKind.TestamentaryEntity) {
    return hasUnacknowledgedRecipientSuggestions;
  }

  return false;
};
